import React, { Component } from "react";
import appl from "../images/del_img/apple.svg";
import avoc from "../images/del_img/avocado.svg";
import broc from "../images/del_img/brocolli.svg";
import chip from "../images/del_img/chips.svg";
import cook from "../images/del_img/cookie.svg";
import egg from "../images/del_img/egg.svg";
import grap from "../images/del_img/grape.svg";
import mang from "../images/del_img/mango.svg";
import oran from "../images/del_img/orange.svg";
import toma from "../images/del_img/tomato.svg";
class Delivery extends Component {
  render() {
    return (
      <>
        <h1 className="text-center my-5">Delivery Areas</h1>
        <div className="container">
          <div className="row my-5">
            <div className="col">
              <div className="text-center">
                <img className="" alt="" src={appl} />
                <p className="text-center fs-1"> Banglore</p>
              </div>
              <div className="row">
                <div className="col">
                  <div className="row fs-5">
                    <p className="">Brookefield</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Mico Layout</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Vijay Nagar</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Shivaji Nagar</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Singasandra</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Marathahalli</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Kalyan Nagar</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Whitefield</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">JP Nagar</p>
                  </div>
                </div>
                <div className="col">
                  <div className="row fs-5">
                    <p className="">KR Puram</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Mico Layout</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">RR Nagar</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Ramamurthy Nagar</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Basavanapura</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Chickpet</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Hebbal</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">BTM Layout</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Malleswaram</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="text-center">
                <img alt="" src={avoc} />
                <p className="text-center fs-1">Chennai</p>
              </div>
              <div className="row">
                <div className="col">
                  <div className="row fs-5">
                    <p className="">Velachery</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Mylapore</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Kk Nagar</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Tambaram</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">T Nagar</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Madambakkam</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Pallikaranai</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Nandambakkam</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Mogappair</p>
                  </div>
                </div>
                <div className="col">
                  <div className="row fs-5">
                    <p className="">Mudichur</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Nanganallur</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Perumbakkam</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Medavakkam</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Perambur</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Gerugambakkam</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Nungambakkam</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Pammal</p>
                  </div>
                  <div className="row fs-5">
                    <p className="">Annanagar</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row my-5">
              <div className="col">
                <div className="text-center">
                  <img alt="" src={broc} />
                  <p className="fs-1 text-center">Delhi</p>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Kirti Nagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">East Of Kailash</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Kalkaji</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Pitampura</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Uttam Nagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Vikaspuri</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Wazirpur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Malviya Nagar</p>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Vasant Kunj</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">South Extension</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Karol Bagh</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Shakti Nagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Janakpuri</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Rajouri Garden</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Paschim Vihar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Sector 10 Dwarka</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div className="text-center">
                  <img alt="" src={chip} />
                  <p className="text-center fs-1">Ghaziabad</p>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Vaishali</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Raj Nagar</p>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Indirapuram</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nanganallur</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container my-5">
            <div className="row">
              <div className="col text-center">
                <div className="text-center">
                  <img alt="" src={cook} />
                  <p className="fs-1 text-center">Gurgaon</p>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Sector 69</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Sector 39</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Sector 27</p>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Ardee City</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Udyog Vihar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Sector 66</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col text-center">
                <div className="text-center">
                  <img alt="" src={egg} />
                  <p className="text-center fs-1">Hyderabad</p>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Nizampet</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Gachibowli</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Sainikpuri</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Moosapet</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nallagandla</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Banjara Hills</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Miyapur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Dammaiguda</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Uppal</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Jublee Hills</p>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Kothapet</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nanganallur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Vivekananda Nagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Kondapur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Himayathnagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Chandanagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Manikonda</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Kukatpally</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Begumpet</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Bowenpally</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="conatiner my-5">
            <div className="row">
              <div className="col">
                <div className="text-center">
                  <img alt="" src={grap} />
                  <p className="text-center fs-1">Kolkata</p>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Velachery</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Mylapore</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Kk Nagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Tambaram</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">T Nagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Madambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Pallikaranai</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nandambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Mogappair</p>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Mudichur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nanganallur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Perumbakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Medavakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Perambur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Gerugambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nungambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Pammal</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Annanagar</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="text-center">
                  <img alt="" src={mang} />
                  <p className="text-center fs-1">Mumbai</p>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Velachery</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Mylapore</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Kk Nagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Tambaram</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">T Nagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Madambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Pallikaranai</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nandambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Mogappair</p>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Mudichur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nanganallur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Perumbakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Medavakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Perambur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Gerugambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nungambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Pammal</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Annanagar</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container my-5">
            <div className="row">
              <div className="col">
                <div className="text-center">
                  <img alt="" src={oran} />
                  <p className="text-center fs-1">Noida</p>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Velachery</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Mylapore</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Kk Nagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Tambaram</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">T Nagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Madambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Pallikaranai</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nandambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Mogappair</p>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Mudichur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nanganallur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Perumbakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Medavakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Perambur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Gerugambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nungambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Pammal</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Annanagar</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="text-center">
                  <img alt="" src={toma} />
                  <p className="text-center fs-1">Pune</p>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Velachery</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Mylapore</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Kk Nagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Tambaram</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">T Nagar</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Madambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Pallikaranai</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nandambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Mogappair</p>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row fs-5">
                      <p className="">Mudichur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nanganallur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Perumbakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Medavakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Perambur</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Gerugambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Nungambakkam</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Pammal</p>
                    </div>
                    <div className="row fs-5">
                      <p className="">Annanagar</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default Delivery;
